/** Analytics common wrapper */

function sendAnalyticsEvent(event, props) {
  sendFacebookEvent(event, props);
  sendGoogleEvent(event, props);
}

function sendGoogleEvent(event, props) {
  if (!gtag) {
    console.warn('Something went wrong with Google global tag code');
    return;
  }
  try {
    gtag('event', event, props);
  } catch (e) {
    console.warn('Something went wrong with Google global tag event sending');
  }
}


const StandartFacebookEvents = [
  'ViewContent',
  'Search',
  'AddToCart',
  'AddToWishlist',
  'InitiateCheckout',
  'AddPaymentInfo',
  'Purchase',
  'Lead',
  'CompleteRegistration',
  'Contact',
  'CustomizeProduct',
  'Donate',
  'FindLocation',
  'PageView',
  'Schedule',
  'StartTrial',
  'SubmitApplication',
  'Subscribe',
];
function sendFacebookEvent(event, props) {
  if (!fbq) {
    console.warn('Something went wrong with Facebook Pixel code');
    return;
  }
  try {
    if(StandartFacebookEvents.includes(event)) {
      fbq('track', event, props)
    } else {
      fbq('customTrack', event, props);
    }
  } catch (e) {
    console.warn('Something went wrong with Facebook Pixel event sending', e);
  }
}
